import * as React from "react";
import type { SVGProps } from "react";
const SvgSuitcase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#suitcase_svg__a)">
      <path d="M20.04 20H3.96C2.88 20 2 19.12 2 18.04V7.96C2 6.88 2.88 6 3.96 6h16.08C21.12 6 22 6.88 22 7.96v10.08c0 1.08-.88 1.96-1.96 1.96M20 7.96 3.96 8 4 18.04 20 18z" />
      <path d="M15 8c-.55 0-1-.45-1-1V5h-4v2c0 .55-.45 1-1 1s-1-.45-1-1V4c0-.55.45-1 1-1h6c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1M7 20c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v12c0 .55-.45 1-1 1M17 20c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1s1 .45 1 1v12c0 .55-.45 1-1 1M4.89 21c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1M19.11 21c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="suitcase_svg__a">
        <path fill="#fff" d="M2 3h20v18H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSuitcase;
